import { connect } from "react-redux";
import AccountStatusCard from "./AccountStatusCard";
import { patchAccount } from "./actions/accounts";

const mapDispatchToProps = (dispatch, ownProps) => {
  const { account } = ownProps;

  return {
    suspendAccount: () => {
      dispatch(patchAccount(account.id, { body: { state: "suspended" } }));
    },
    closeAccount: () => {
      dispatch(patchAccount(account.id, { body: { state: "closed" } }));
    },
    reviewAccount: () => {
      dispatch(patchAccount(account.id, { body: { state: "review" } }));
    },
    activateAccount: () => {
      dispatch(patchAccount(account.id, { body: { state: "active" } }));
    }
  };
};

const AccountStatusCardContainer = connect(null, mapDispatchToProps)(
  AccountStatusCard
);

export default AccountStatusCardContainer;



// WEBPACK FOOTER //
// ./src/AccountStatusCardContainer.js